import IconFindEstimate from '@icon/house/find-estimate.svg'
import FindEstimateButton from './button'

export default function FindEstimate({
  data
}) {

  return (
    <div className='border rounded-sm p-20 flex flex-col justify-between gap-y-10'>
      <div className='text-lg font-medium text-center'>Interested in {data.district}?</div>
      <IconFindEstimate className='mx-auto' />
      <FindEstimateButton data={data} />
    </div>
  )
}
